export const SET_INSTAGRAM_TOKEN: string = "SET_INSTAGRAM_TOKEN";
export const SET_INSTAGRAM_TOKEN_SUCCESS: string =
  "SET_INSTAGRAM_TOKEN_SUCCESS";
export const SET_INSTAGRAM_TOKEN_FAIL: string = "SET_INSTAGRAM_TOKEN_FAIL";
export const RESET_INSTAGRAM_TOKEN: string = "RESET_INSTAGRAM_TOKEN";
